/**
 * Created by Daniel
 * Description:
 * ---------maintenance history-------------
 */

import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { Subscription } from 'rxjs';
import { DisplayConfig, ShowAsMode, OPEN_FILTER_DIALOG, CHANGE_SHOW_LIST_MODE, SHOW_CALENDAR_EVENTS } from './display.model';

import { AppState } from '../../redux';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/internal/operators/map';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'display',
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.scss']
})
export class DisplayComponent implements OnInit, OnDestroy {
    @Input() config: DisplayConfig;

    filterContextMenuConfig: ContextMenuConfig;
    iconName = 'filter';

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _store: Store<AppState>,
    ) { }


    ngOnInit() {
        this._initContextMenu();
        this._changeDisplayInfo(this.config);

        this._destroySubscriptions.push(
            this.config.actions$.subscribe(action => this._onSubscribeActions(action))
        );
        this._selectFilterData();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    onFilterSelect(event) {

        if (event.payload.id === 0) {
            this.filterContextMenuConfig.items[0].checked = !this.filterContextMenuConfig.items[0].checked;

            this.config.events$.next({
                type: CHANGE_SHOW_LIST_MODE,
                payload: this.filterContextMenuConfig.items[0].checked ? ShowAsMode.NOTES : ShowAsMode.THREADS
            });
        } else if (event.payload.id === 1) {
            this.filterContextMenuConfig.items[1].checked = !this.filterContextMenuConfig.items[1].checked;
            this.config.events$.next({
                type: SHOW_CALENDAR_EVENTS,
                payload: this.filterContextMenuConfig.items[1].checked
            });
        } else {
            this.config.events$.next({
                type: OPEN_FILTER_DIALOG,
            });
        }
        this._changeDetectorRef.detectChanges();
    }

    onShowFilterContextMenu(e: MouseEvent) {
        this.filterContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    private _changeDisplayInfo(action?) {
        if (action) {
            this.config = action;
        }

        if (this.config) {
            if (this.config.showAsMode === 0) {
                this.filterContextMenuConfig.items[0].checked = true;
            } else {
                this.filterContextMenuConfig.items[0].checked = false;
            }

            if (this.config.showCalendarEvents) {
                this.filterContextMenuConfig.items[1].checked = true;
            } else {
                this.filterContextMenuConfig.items[1].checked = false;
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    private _initContextMenu() {
        this.filterContextMenuConfig = new ContextMenuConfig();
        this.filterContextMenuConfig.single = true;
        this.filterContextMenuConfig.items = [
            { id: 0, text: 'Show Sidenotes' },
            { id: 1, text: 'Show Calendar Events' },
            { divider: true },
            { id: 2, text: 'Advanced Filtering...' }
        ];

        this.filterContextMenuConfig.events$.subscribe(event => this.onFilterSelect(event));
    }

    private _onSubscribeActions(action) {
        this._changeDisplayInfo(action);
    }
    /**
     * get filter status from store.
     */
    private _selectFilterData() {
        this._destroySubscriptions.push(
            this._store.pipe(
                select(this.config.filterStatusSelector),
                map(status => status ? 'filter' : 'filter-o'),
            ).subscribe(status => this.iconName = status)
        );
    }
}
